import script from "./PropertyInfoComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyInfoComponent.vue?vue&type=script&setup=true&lang=js"

import "./PropertyInfoComponent.vue?vue&type=style&index=0&id=757d2d74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-757d2d74"]])

export default __exports__